export class PublicBlogApiError extends Error {
  public readonly status?: number;

  public constructor(operation: string, status?: number) {
    super(
      `Public blog ${operation} request failed${status ? ` with status ${status}` : ''}.`
    );
    this.name = 'PublicBlogApiError';
    this.status = status;
  }
}
